import React from "react"
import styles from "./Header.module.css"

export const Header = () => {
  return (
  <div>
      <h1 className={styles.header}>
        Rick and Morty
      </h1>
    </div>
  )
}
